import React, { useEffect, useState } from 'react';
import { filter, Subject, takeUntil } from 'rxjs';

import useStyles from 'isomorphic-style-loader/useStyles';
import {
	Container, DataService, XpSourceName, i18n,
} from '../../../../../symphony';

import { Widget } from '../../Widget/Widget';
import { SlLEContext } from '../../../global-constants';
import { SlDataService } from '../../../services/sl-data.service';
import {
	ActionType,
	IMaterialProps,
	IWidgetData,
	RequestType,
} from '../../../global-interface';
import { SlActions } from '../../../services/ActionsService/sl-actions';

import s from './CodeCoach.scss';

export function CodeCoach({ materialInfo }: IMaterialProps): JSX.Element {
	useStyles(s);
	const {
		header: {
			title, description, typeId, id, materialRelationId,
		},
		status,
		options,
	} = materialInfo;

	const { xpSourcesList$ } = Container.take('global', DataService);
	const [isCurrentCC, setIsCurrentCC] = useState<boolean>(false);

	const xp = xpSourcesList$.value?.xpSources.find(
		(item) => item.sourceName === XpSourceName.CodeCoachSolve,
	)?.xp;

	const onPracticeClickHandler = () => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.onCCPracticeClick,
			requestType: RequestType.Parallel,
			data: {
				materialInfo,
			},
		});
	};
	useEffect(() => {
		const { currentItems$ } = Container.take(SlLEContext, SlDataService);

		const unsubscriber = new Subject<void>();

		currentItems$
			.pipe(
				takeUntil(unsubscriber),
				filter((i) => !!i),
			)
			.subscribe((items) => setIsCurrentCC(
				items.some(({ materialId }) => materialId === materialRelationId),
			));

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	const widgetData: IWidgetData = {
		status,
		title,
		description,
		type: typeId,
		xp,
		button: {
			title: i18n.t('web-le.material-type-practice'),
			onClick: onPracticeClickHandler,
		},
		isCurrent: isCurrentCC,
	};

	return (
		<div
			sl-test-data="cmpCodeCoach"
			className="le-code-coach"
			le-data-id={materialRelationId}
		>
			<Widget
				parentType={options.parentType}
				widget={widgetData}
				onClick={onPracticeClickHandler}
				id={id}
			/>
		</div>
	);
}
